import { render, staticRenderFns } from "./unionpayInstallmentFinished.vue?vue&type=template&id=6dd850c6&scoped=true&"
import script from "./unionpayInstallmentFinished.vue?vue&type=script&lang=js&"
export * from "./unionpayInstallmentFinished.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd850c6",
  null
  
)

export default component.exports